<link rel="preconnect" href="https://fonts.googleapis.com">
<link href="https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;1,400&family=DM+Sans:wght@300;400;500&display=swap" rel="stylesheet">

<!-- NAVIGATION: Updated to point directly to /portfolio to avoid redirect loops -->
<nav class="main-nav">
  <a [routerLink]="['/portfolio']" class="logo">
    <img src="devflow.png" alt="NV">
  </a>
  <ul class="nav-links">
    <li><a [routerLink]="['/portfolio']" fragment="about">Who am I?</a></li>
    <li><a [routerLink]="['/portfolio']" fragment="projects">Projects</a></li>
    <li><a [routerLink]="['/portfolio']" fragment="skills">Skills</a></li>
    <li><a [routerLink]="['/portfolio']" fragment="contact">Contact</a></li>
    <li><a [routerLink]="['/kanban']" routerLinkActive="active">Admin</a></li>
  </ul>
</nav>

<!-- SECTION 1: Who am I? -->
<section id="about" class="about-section">
  <div class="blob-bg"></div>
  <div class="blob-bg blob-bg--right"></div>

  <div class="about-inner">
    <div class="about-text">
      <div class="section-eyebrow">Who am I?</div>
      <h1 class="about-name">
        Nicolai Kristian<br><em>Vestergaard</em>
      </h1>
      <div class="study-pills">
        <span class="study-pill">Medialogy (BSc)</span>
        <span class="study-pill">6th Semester — Aalborg University</span>
      </div>
      <p class="about-body">
        I am currently finishing my Bachelor's degree in Medialogy at Aalborg University. With a background specialising in the intersection of technology and creativity, I have developed a strong foundation in both front-end and back-end development.
      </p>
      <p class="about-body">
        Over the past four years I have worked extensively with C# and Unity, and more recently immersed myself in full-stack web development using the MEAN stack.
      </p>

      <div class="about-actions">
        <!-- Internal buttons updated to /portfolio path -->
        <a [routerLink]="['/portfolio']" fragment="projects" class="about-cta-primary">See my work ↓</a>
        <a [routerLink]="['/portfolio']" fragment="contact" class="about-cta-ghost">Get in touch</a>
      </div>
    </div>

    <div class="about-photo-side">
      <div class="about-photo-wrap">
        <img src="PictureOfMe.jpg" alt="Nicolai Vestergaard" class="about-photo">
        <div class="photo-deco-ring"></div>
        <div class="photo-badge">
          <span class="badge-dot"></span>
          Open to work
        </div>
      </div>
    </div>
  </div>
</section>

<!-- SECTION 2: Projects Bridge -->
<div id="projects" class="section-bridge">
  <div class="bridge-line"></div>
  <div class="section-eyebrow">Selected Work</div>
  <h2 class="bridge-heading">Projects</h2>
  <p class="bridge-sub">Where code meets design and ideas become meaningful solutions.</p>
</div>

<div class="portfolio-container">
  <button class="side-arrow left" (click)="scroll(-1)" [disabled]="currentIndex === 0">〈</button>
  <button class="side-arrow right" (click)="scroll(1)" [disabled]="currentIndex === projects.length - 1">〉</button>

  @if (projects.length === 0) {
  <div class="loading-message">Waking up the server... please wait a moment.</div>
  }
  <div class="card-viewer" #cardViewer (scroll)="onScroll()">
    @for (project of projects; track project._id) {
      <div class="project-card" [style.border-top]="'3px solid ' + (project.color || '#6FAF8F')">
        <div class="project-img-wrap">
          <img [src]="project.imageUrl || 'assets/placeholder.jpg'" class="project-img" alt="{{project.title}}">
        </div>
        <div class="card-content">
          <span class="click-count">Clicks: {{ project.clicks || 0 }}</span>
          <h3>{{ project.title }}</h3>
          <p>{{ project.desc }}</p>
          <button class="primary-btn" (click)="trackClick(project._id)">View Details →</button>
        </div>
      </div>
    }
  </div>
</div>

<div class="dots-row-container">
  <div class="dots-row">
    @for (p of projects; track p._id; let i = $index) {
      <div class="dot" [class.active]="i === currentIndex" (click)="scroll(i - currentIndex)"></div>
    }
  </div>
</div>

<!-- SECTION 3: Skills Bridge -->
<div class="section-bridge" id="skills">
  <div class="bridge-line"></div>
  <div class="section-eyebrow">Toolbox</div>
  <h2 class="bridge-heading">Skills</h2>
  <p class="bridge-sub">Languages, frameworks, and tools I work with every day.</p>
</div>

<section class="skills-section">
  <div class="skill-category">
    <h3>Programming & Development</h3>
    <div class="skills-grid">
      <div class="skill-tile"><img src="https://cdn.simpleicons.org/c?color=F5F5F4"><span>C#</span></div>
      <div class="skill-tile"><img src="https://cdn.simpleicons.org/kotlin?color=F5F5F4"><span>Kotlin</span></div>
      <div class="skill-tile"><img src="https://cdn.simpleicons.org/javascript?color=F5F5F4"><span>JavaScript</span></div>
      <div class="skill-tile"><img src="https://cdn.simpleicons.org/python?color=F5F5F4"><span>Python</span></div>
      <div class="skill-tile"><img src="https://cdn.simpleicons.org/php?color=F5F5F4"><span>PHP</span></div>
      <div class="skill-tile"><img src="https://cdn.simpleicons.org/r?color=F5F5F4"><span>R</span></div>
    </div>
  </div>

  <div class="skill-category">
    <h3>Web & Frameworks</h3>
    <div class="skills-grid">
      <div class="skill-tile"><img src="https://cdn.simpleicons.org/html5?color=F5F5F4"><span>HTML5</span></div>
      <div class="skill-tile"><img src="https://cdn.simpleicons.org/css?color=F5F5F4"><span>CSS3</span></div>
      <div class="skill-tile"><img src="https://cdn.simpleicons.org/angular?color=F5F5F4"><span>Angular</span></div>
      <div class="skill-tile"><img src="https://cdn.simpleicons.org/aframe?color=F5F5F4"><span>AJAX</span></div>
      <div class="skill-tile"><img src="https://cdn.simpleicons.org/json?color=F5F5F4"><span>JSON</span></div>
    </div>
  </div>

  <div class="skill-category">
    <h3>Backend & Databases</h3>
    <div class="skills-grid">
      <div class="skill-tile"><img src="https://cdn.simpleicons.org/mysql?color=F5F5F4"><span>MySQL</span></div>
      <div class="skill-tile"><img src="https://cdn.simpleicons.org/mongodb?color=F5F5F4"><span>MongoDB</span></div>
      <div class="skill-tile"><img src="https://cdn.simpleicons.org/express?color=F5F5F4"><span>Express</span></div>
      <div class="skill-tile"><img src="https://cdn.simpleicons.org/angular?color=6FAF8F"><span>MEAN Stack</span></div>
    </div>
  </div>

  <div class="skill-category">
    <h3>Tools & Software</h3>
    <div class="skills-grid">
      <div class="skill-tile"><img src="https://cdn.simpleicons.org/github?color=F5F5F4"><span>GitHub</span></div>
      <div class="skill-tile"><img src="https://cdn.simpleicons.org/unity?color=F5F5F4"><span>Unity</span></div>            
      <div class="skill-tile"><img src="https://cdn.simpleicons.org/miro?color=F5F5F4"><span>Miro</span></div>
      <div class="skill-tile"><img src="https://cdn.simpleicons.org/figma?color=F5F5F4"><span>Figma</span></div>
      <div class="skill-tile"><img src="https://cdn.simpleicons.org/rstudioide?color=F5F5F4"><span>RStudio</span></div>
      <div class="skill-tile"><img src="https://cdn.simpleicons.org/aseprite?color=F5F5F4"><span>Aseprite</span></div>
    </div>
  </div>
</section>

<!-- SECTION 4: Contact -->
<section id="contact" class="contact-section">
  <div class="contact-inner">
    <div class="section-eyebrow">Get in touch</div>
    <h2 class="contact-heading">Let's work<br><em>together</em></h2>
    <p class="contact-sub">My inbox is always open.</p>
    
    <div class="contact-actions">
      <a href="https://mail.google.com/mail/u/0/#inbox?compose=GTvVlcSBmzhHLHrhzCcQklzThFtKFvLtrdJnPbMndCwBlxFrtFCNkJgwPLpVsclPjhQTqjkKDrSfk" class="contact-btn">
        Send me a message →
      </a>
  
      <button class="copy-email-btn" (click)="copyEmail()">
        Or copy email address
      </button>
    </div>

    <div class="project-meta">
      <a href="https://github.com/Nicolatian" target="_blank" class="meta-chip github">
        <img src="https://cdn.simpleicons.org/github?color=F5F5F4" class="chip-icon-img" alt="">
        GitHub
      </a>
      <a href="https://www.linkedin.com/in/nicolatian-vestergaard-7280b535b/" target="_blank" class="meta-chip github">
        <img src="https://api.iconify.design/simple-icons:linkedin.svg?color=%23F5F5F4" class="chip-icon-img" alt="LinkedIn">
        LinkedIn
      </a>
    </div>
  </div>
</section>

<footer class="footer">
  <p>2026 - Designed by Me & Built by Me</p>
</footer>
